export const MASK = [/\d/, /\d/, ':', /\d/, /\d/];
